var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.027,
    x2: 1,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d0b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5fa2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14536",
    "data-name": "Path 14536",
    d: "M20749.264,20560a2.486,2.486,0,0,1-2.488-2.482v-4.256a2.488,2.488,0,0,1,2.488-2.484h4.256a2.485,2.485,0,0,1,2.48,2.484v4.256a2.483,2.483,0,0,1-2.48,2.482Zm-10.777,0a2.486,2.486,0,0,1-2.486-2.482v-4.256a2.487,2.487,0,0,1,2.486-2.484h4.256a2.485,2.485,0,0,1,2.48,2.484v4.256a2.483,2.483,0,0,1-2.48,2.482Zm10.777-10.779a2.484,2.484,0,0,1-2.488-2.48v-4.256a2.488,2.488,0,0,1,2.488-2.484h4.256a2.485,2.485,0,0,1,2.48,2.484v4.256a2.481,2.481,0,0,1-2.48,2.48Zm-10.777,0a2.484,2.484,0,0,1-2.486-2.48v-4.256a2.487,2.487,0,0,1,2.486-2.484h4.256a2.485,2.485,0,0,1,2.48,2.484v4.256a2.481,2.481,0,0,1-2.48,2.48Z",
    transform: "translate(-20736 -20540.002)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardActive);
export default __webpack_public_path__ + "static/media/icon-dashboard-active.4cb6fabf75b40216d3201fd16034c957.svg";
export { ForwardRef as ReactComponent };